import { PropsWithChildren } from 'react';
import { DisplayText, cn } from '@bridebook/aura';

export interface ISharedProps {
  className?: string;
}

interface IProps extends ISharedProps, PropsWithChildren {}

const Heading = ({ children, className }: IProps) => (
  <DisplayText
    as="h1"
    variant="display-3xl"
    className={cn('my-4 mb-2 lg:mt-8 lg:mb-0', className)}
    data-name="heading">
    {children}
  </DisplayText>
);

export default Heading;
